import React from 'react';
import { TableHead, TableRow } from '@mui/material';

import CurrentTableContext from 'components/shared/CustomTable/context';

import CustomTableCell from './CustomTableCell';

const CustomTableHead = () => {
  const { columns } = React.useContext(CurrentTableContext);

  return (
    <TableHead>
      <TableRow>
        {columns
          .filter((column) => column.status)
          .map((column, index) => (
            <CustomTableCell key={index} column={column} index={index} />
          ))}
      </TableRow>
    </TableHead>
  );
};

export default CustomTableHead;
